import Home from "../Home/Home";
import { useSelector } from "react-redux";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { addActiveEventData, addEventData } from "../../store/adminSlice";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

const ActiveEventDetail = () => {
  let activeEventData = useSelector((state) => state.activeEventData);
  const [openLoader, setOpenLoader] = useState(true);
  const [priceTableList, setPriceTableList] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const hasFetched = useRef(false);


  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    if (activeEventData.eventId) {
      createTableList(activeEventData)
      setOpenLoader(false);
      // setEventType();
    } else {
      fetch(process.env.REACT_APP_API_URL + "/event/get/latest/active")
        .then((response) => response.json())
        .then((activeData) => {
          if (activeData && activeData.eventId) {
            createTableList(activeData)
            dispatch(addActiveEventData(activeData));
            // setEventType();
            fetch(
              process.env.REACT_APP_API_URL +
                "/event/registration/get/summary/" +
                activeData.eventId
            )
              .then((response) => response.json())
              .then((data) => {
                if (data && data.eventId) {
                  dispatch(addEventData(data));
                  setOpenLoader(false);
                } else {
                  setOpenLoader(false);
                }
              })
              .catch((error) => {
                console.error("Error fetching event:", error);
                setOpenLoader(false);
              });
          } else {
            setOpenLoader(false);
            //   setActiveEvent(null);
          }
        })
        .catch((error) => {
          console.error("Error fetching event:", error);
          setOpenLoader(false);
        });
    }
  }, []);

    function formatDate(date) {
        if (!date) return "";

        const [year, month, day] = date.split("-");

        return `${day}/${month}/${year}`;
    }

  function createTableList(activeEvent) {

    let pricetableList =
        activeEvent.eventCode === 1 ||
        activeEvent.eventCode === 3 ||
        activeEvent.eventCode === 4
            ? [{
              name: "Price",
              value1: activeEvent.priceAdult,
              value2: 70, //this is dummy member adult price. Needs to come from DB
              value3: activeEvent.priceBelow6,
              value4: activeEvent.price6to12,
              value5: 40 //this is dummy member 6-12 price. Needs to come from DB
            }]
            : [{
              name: "Sat & Sun Both",
              value1: activeEvent.priceAdult,
              value2: 150,
              value3: activeEvent.priceBelow6,
              value4: activeEvent.price6to12,
              value5: 70
            }];

    if (activeEvent.satOnlyStatus === "A") {
      pricetableList.push({
        name: "Saturday Only",
        value1: activeEvent.saturdayPriceAdult,
        value2: 75,
        value3: activeEvent.saturdayPriceBelow6,
        value4: activeEvent.saturdayPrice6To12,
        value5: 40
      });
    }

    if (activeEvent.sunOnlyStatus === "A") {
      pricetableList.push({
        name: "Sunday Only",
        value1: activeEvent.sundayPriceAdult,
        value2: 90,
        value3: activeEvent.sundayPriceBelow6,
        value4: activeEvent.sundayPrice6To12,
        value5: 40
      });
    }

    if (activeEvent.eventOnlyStatus === "A") {
      pricetableList.push({
        name: "Concert Only",
        value1: "",
        value2: "",
        value3: "",
        value4: "",
		value5: "",
        value6: activeEvent.eventOnlyPriceAdult
      });
    }

    // FIXED: eventCode (not eventcode)
    if (activeEvent.eventCode === 2) {
      pricetableList.push({
        name: "At the door-All days",
        value1: 170,
        value2: 160,
        value3: 0,
        value4: 85,
        value5: 75
      });

      pricetableList.push({
        name: "At the door-Saturday",
        value1: 80,
        value2: 75,
        value3: 0,
        value4: 45,
        value5: 40
      });

      pricetableList.push({
        name: "At the door-Sunday",
        value1: 95,
        value2: 90,
        value3: 0,
        value4: 45,
        value5: 40
      });
    }

    setPriceTableList(pricetableList);
  }

  function formatDateForSow(dateStr) {
    console.log(dateStr);
    const [day, month, year] = dateStr.split("/").map(Number);
    const date = new Date(year, month - 1, day);

    const dayWithSuffix = day + getDaySuffix(day);
    const monthName = date.toLocaleString("default", { month: "long" });
    const weekday = date.toLocaleString("default", { weekday: "long" });

    return `${dayWithSuffix} ${monthName}, ${year} ${weekday}`;
  }

  function formatDateForSowForDurgaPuja(dateStrStart, dateStrEnd) {
    const [day1, month1, year1] = dateStrStart.split("/").map(Number);
    const [day2, month2, year2] = dateStrEnd.split("/").map(Number);
    const date1 = new Date(year1, month1 - 1, day1);
    const date2 = new Date(year2, month2 - 1, day2);

    const dayWithSuffix1 = day1 + getDaySuffix(day1);
    const monthName1 = date1.toLocaleString("default", { month: "long" });
    const weekday1 = date1.toLocaleString("default", { weekday: "long" });

    const dayWithSuffix2 = day2 + getDaySuffix(day2);
    const monthName2 = date2.toLocaleString("default", { month: "long" });
    const weekday2 = date2.toLocaleString("default", { weekday: "long" });

    return `${dayWithSuffix1} ${monthName1} - ${dayWithSuffix2} ${monthName2}, ${year1} ${weekday1} - ${weekday2}`;
  }

  function getDaySuffix(day) {
    if (day >= 11 && day <= 13) return "th";
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  }

  return (
    <>
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={openLoader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Home>
        <img
          style={{ height: "450px", width: "100%" }}
          src={`../../eventPicture/${activeEventData.eventCode}.jpg`}
        />

        <div className="container">

          {activeEventData.eventCode === 2 &&
          <div className="row">
            <div className="col-md-8 off offset-md-2">
            <h3 style={{ textAlign: "center" }}>Price Details</h3>
            {priceTableList?.length > 0 &&
            <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                              <TableHead>
                                <TableRow>
                                  <TableCell></TableCell>
                                  <TableCell>
                                    <b>Adult Non-Member (Veg & Non-Veg)</b>
                                  </TableCell>
                                  <TableCell>
                                    <b>Adult Member (Veg & Non-Veg)</b>
                                  </TableCell>
                                  <TableCell>
                                    <b>Below 6 (Member & Non-Member)</b>
                                  </TableCell>
                                  <TableCell>
                                    <b>Age 6 To 12 (Non-Member)</b>
                                  </TableCell>
                                  <TableCell>
                                    <b>Age 6 To 12 (Member)</b>
                                  </TableCell>
								  {/*<TableCell>
									<b>Event Only</b>
								  </TableCell>*/}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {priceTableList.map((priceObj, index) => (
                                    <TableRow
                                        key={index}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                      <TableCell>
                                        <b>{priceObj.name}</b>
                                      </TableCell>

                                      <TableCell>{priceObj.value1}</TableCell>
                                      <TableCell>{priceObj.value2}</TableCell>
                                      <TableCell>{priceObj.value3}</TableCell>
                                      <TableCell>{priceObj.value4}</TableCell>
                                      <TableCell>{priceObj.value5}</TableCell>
									  {/*<TableCell>{priceObj.value6}</TableCell>*/}
                                    </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                        </TableContainer>
                  }
            </div>
          </div>
        }
		
		{(activeEventData.eventCode === 1 || activeEventData.eventCode === 3 || activeEventData.eventCode === 4)  &&
          <div className="row">
            <div className="col-md-8 off offset-md-2">
            <h3 style={{ textAlign: "center" }}>Price Details</h3>
            {priceTableList?.length > 0 &&
            <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell> </TableCell>
                                        <TableCell> <b> Adult Non-Member (Veg & Non-Veg) </b ></TableCell>
                                        <TableCell> <b> Adult Member (Veg & Non-Veg) </b> </TableCell>
                                        <TableCell><b> Below 6 (Member & Non-Member) </b> </TableCell>
                                        <TableCell> <b> Age 6 To 12 (Non-Member) </b> </TableCell>
										<TableCell> <b> Age 6 To 12 (Member) </b> </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                  {priceTableList.map((priceObj, index) => (
                                    <TableRow
                                    key={index}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell><b>{priceObj.name}</b></TableCell>
                                        <TableCell>{priceObj.value1}</TableCell>
                                        <TableCell>{priceObj.value2}</TableCell>
                                        <TableCell>{priceObj.value3}</TableCell>
                                        <TableCell>{priceObj.value4}</TableCell>
										<TableCell>{priceObj.value5}</TableCell>
                                    </TableRow>
                                 ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                  }
            </div>
          </div>
        }

          <div className="row" style={{ marginTop: "20px" }}>
            <div className="col-md-4 off offset-md-4">
              <div className="container1">
               {activeEventData.eventCode !== 2 && (
				<>
					<header>
						<h1 className="title1">UDAAN</h1>
					</header>
					<p className="invite-text1">invites you to</p>
				</>
			   )}

                  <h2 className="event-title1">
					{activeEventData.eventCode === 4 &&	`Summer Picnic, ${formatDate(activeEventData.eventEndDate).slice(-2)}`}
					{activeEventData.eventCode === 3 &&	`Bengali New Year, ${formatDate(activeEventData.eventEndDate).slice(-2)}`}
					{activeEventData.eventCode === 2 &&	`Durga Pujo, ${formatDate(activeEventData.eventEndDate).slice(-2)}`}
					{activeEventData.eventCode === 1 && `Saraswati Pujo, ${formatDate(activeEventData.eventEndDate).slice(-2)}`}
				 </h2>
				
                <p className="date1">
                  {activeEventData.eventCode !== 2 && `on ${formatDateForSow(formatDate(activeEventData.eventEndDate))}`}
                  {activeEventData.eventCode === 2 && `on ${formatDateForSowForDurgaPuja(
                    formatDate(activeEventData.eventStartDate), formatDate(activeEventData.eventEndDate))}`}
                </p>
                <div className="venue-info1">
                  <p>
                    <strong>Venue:</strong>
                    {`${activeEventData.eventVenue}`}
                  </p>
                  <p>
                    <strong>Address:</strong>
                    {`${activeEventData.eventStreet}, ${activeEventData.eventCity} , ${activeEventData.eventZip}`}
                  </p>
                </div>
                {activeEventData.registrationStatus === "open" && (
                <Button
                  variant="contained"
                  style={{ marginRight: "20px",  marginTop : "20px"}}
                  onClick={() => navigate("/event/registration")}
                >
                  Register Now
                </Button>
              )}
              </div>
            </div>
          </div>
        </div>

        
      </Home>
    </>
  );
};

export default ActiveEventDetail;
